import React from 'react';

function PrimaryButton(props) {
  const wrapperClass = "flex items-center justify-center px-10 py-2 whitespace-no-wrap " +
    "bg-primary-button text-black font-semibold text-xs " +
    "cursor-pointer hover:bg-primary-button-hover";
  return (
    <div 
      onClick={props.onClick}
      className={wrapperClass}>
      {props.buttonText}
    </div>
  );
}

export default PrimaryButton;